import React from 'react'
import styles from './Button.module.css'
function Button(props) {
    let disabled = props.disabled || false
    let style = props.style || {}
    const buttonClick = () => {
        if (!disabled) {
            props.onClick()
        }
    }
    return (
        <div
            onClick={() => { buttonClick() }}
            className={`${styles.button} ${disabled ? styles.disabled : ''} `}
            style={style}
        >{props.children}</div>
    )
}

export default Button